import { isStorageAvailable } from '../../common/utils/isStorageAvailable';

const LOCALSTORAGE_KEY = 'giftbox-debug';
const LOG_PREFIX = 'GiftBox: ';
let loggingEnabled = false;
if (isStorageAvailable()) {
  loggingEnabled = !!localStorage.getItem(LOCALSTORAGE_KEY);
}

window.giftBoxEnableDebug = () => {
  if (isStorageAvailable()) {
    localStorage.setItem(LOCALSTORAGE_KEY, true);
  }
  loggingEnabled = true;
  logInfo('Enabled console output 🔧');
};

export function logError(message, ...rest) {
  if (!loggingEnabled) {
    return;
  }

  const errorMessage =
    typeof message === 'string' ? LOG_PREFIX + message : message;
  console.error(errorMessage, ...rest);
}

export function logInfo(message, ...rest) {
  if (!loggingEnabled) {
    return;
  }

  const prefixedMessage =
    typeof message === 'string' ? LOG_PREFIX + message : message;
  console.info(prefixedMessage, ...rest);
}
